module.exports = __webpack_public_path__ + "static/media/escudo.dfa086dc.svg";